<template>
  <v-container fluid :class="{ 'recepcion-dark': $vuetify.theme.dark }">
    <v-row class="mb-2" align="center">
      <v-col>
        <span class="text-h6 font-weight-bold">Registro de Archivo Unico</span>
      </v-col>
      <v-col cols="12" sm="5" md="5" class="py-0 d-flex align-center justify-md-end justify-start">
        <v-btn outlined color="info" :loading="cargandoListado" @click="abrirListado">
          <v-icon left>fas fa-table</v-icon>
          Registros cargados
        </v-btn>
      </v-col>
    </v-row>

    <v-card outlined class="pa-4">
      <v-form ref="form" v-model="formValido">
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="ordenServicio"
              label="Número de orden de servicio *"
              outlined
              dense
              :rules="reglasOrden"
              @input="ordenServicio = String(ordenServicio || '').replace(/\\s/g, '').replace(/[^0-9]/g, '')"
            />
          </v-col>
        </v-row>

        <v-divider class="my-4" />
        <div class="text-subtitle-2 mb-3 recepcion-section-title">Fotografías</div>
        <v-row dense>
          <v-col cols="12" sm="6">
            <div class="field-label">Foto odómetro *</div>
            <button v-if="!previewOdometro" type="button" class="upload-placeholder upload-placeholder--single" @click="$refs.inOdometro.click()">
              <v-icon color="primary" size="64">fas fa-plus</v-icon>
              <span class="upload-hint">Tocá para agregar</span>
            </button>
            <div v-else class="thumb-cell thumb-cell--single">
              <img :src="previewOdometro" alt="" @click="openViewer(previewOdometro, 'Odómetro')">
              <v-btn icon x-small dark class="thumb-remove" aria-label="Quitar" @click.stop="clearSingle('fotoOdometro', 'previewOdometro')"><v-icon x-small>fas fa-times</v-icon></v-btn>
            </div>
            <input ref="inOdometro" type="file" accept="image/*" class="d-none" @change="onPickSingle($event, 'fotoOdometro', 'previewOdometro')">
          </v-col>

          <v-col cols="12" sm="6">
            <div class="field-label">Foto VIN *</div>
            <button v-if="!previewVin" type="button" class="upload-placeholder upload-placeholder--single" @click="$refs.inVin.click()">
              <v-icon color="primary" size="64">fas fa-plus</v-icon>
              <span class="upload-hint">Tocá para agregar</span>
            </button>
            <div v-else class="thumb-cell thumb-cell--single">
              <img :src="previewVin" alt="" @click="openViewer(previewVin, 'VIN')">
              <v-btn icon x-small dark class="thumb-remove" aria-label="Quitar" @click.stop="clearSingle('fotoVin', 'previewVin')"><v-icon x-small>fas fa-times</v-icon></v-btn>
            </div>
            <input ref="inVin" type="file" accept="image/*" class="d-none" @change="onPickSingle($event, 'fotoVin', 'previewVin')">
          </v-col>

          <v-col cols="12">
            <div class="field-label">Foto parte implicada en la falla *</div>
            <div class="thumb-grid">
              <div v-for="(url, i) in previewFallas" :key="'f' + i" class="thumb-cell">
                <img :src="url" alt="" @click="openViewer(url, 'Falla ' + (i + 1))">
                <v-btn icon x-small dark class="thumb-remove" aria-label="Quitar" @click.stop="removeFalla(i)"><v-icon x-small>fas fa-times</v-icon></v-btn>
              </div>
              <button type="button" class="upload-placeholder" @click="$refs.inFallas.click()">
                <v-icon color="primary" size="64">fas fa-plus</v-icon>
              </button>
            </div>
            <input ref="inFallas" type="file" accept="image/*" multiple class="d-none" @change="onPickFallas">
          </v-col>

          <v-col cols="12" sm="6">
            <div class="field-label">Foto de la patente (opcional)</div>
            <button v-if="!previewPatente" type="button" class="upload-placeholder upload-placeholder--single" @click="$refs.inPatente.click()">
              <v-icon color="primary" size="64">fas fa-plus</v-icon>
              <span class="upload-hint">Tocá para agregar</span>
            </button>
            <div v-else class="thumb-cell thumb-cell--single">
              <img :src="previewPatente" alt="" @click="openViewer(previewPatente, 'Patente')">
              <v-btn icon x-small dark class="thumb-remove" aria-label="Quitar" @click.stop="clearSingle('fotoPatente', 'previewPatente')"><v-icon x-small>fas fa-times</v-icon></v-btn>
            </div>
            <input ref="inPatente" type="file" accept="image/*" class="d-none" @change="onPickSingle($event, 'fotoPatente', 'previewPatente')">
          </v-col>

          <v-col cols="12" sm="6">
            <div class="field-label">Print de consulta al CAT (opcional)</div>
            <div class="thumb-grid">
              <div v-for="(url, i) in previewCat" :key="'c' + i" class="thumb-cell">
                <img :src="url" alt="" @click="openViewer(url, 'CAT ' + (i + 1))">
                <v-btn icon x-small dark class="thumb-remove" aria-label="Quitar" @click.stop="removeCat(i)"><v-icon x-small>fas fa-times</v-icon></v-btn>
              </div>
              <button type="button" class="upload-placeholder" @click="$refs.inCat.click()">
                <v-icon color="primary" size="64">fas fa-plus</v-icon>
              </button>
            </div>
            <input ref="inCat" type="file" accept="image/*" multiple class="d-none" @change="onPickCat">
          </v-col>
        </v-row>

        <v-divider class="my-4" />
        <div class="text-subtitle-2 mb-3">Número de parte/repuesto</div>
        <v-row dense class="repuesto-row" v-for="(r, i) in repuestos" :key="`r-${i}`">
          <v-col cols="12" sm="7" class="py-0">
            <v-text-field v-model="r.numero_parte" label="Número de parte" outlined dense hide-details />
          </v-col>
          <v-col cols="8" sm="4" class="py-0">
            <v-text-field
              v-model.number="r.cantidad"
              label="Cantidad"
              type="number"
              min="1"
              step="1"
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="4" sm="1" class="py-0 d-flex justify-center align-start repuesto-delete-col">
            <v-btn icon color="error" class="repuesto-delete-btn" @click="removeRepuesto(i)"><v-icon>fas fa-trash</v-icon></v-btn>
          </v-col>
        </v-row>
        <v-btn small outlined color="primary" class="mb-3 mt-3" @click="addRepuesto">
          <v-icon left x-small>fas fa-plus</v-icon>Agregar repuesto
        </v-btn>

        <v-row class="mt-4">
          <v-col>
            <v-btn color="primary" :loading="enviando" :disabled="!puedeEnviar" @click="enviar">
              <v-icon left>fas fa-paper-plane</v-icon>
              Enviar registro
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>

    <v-dialog v-model="dialogListado" max-width="1200px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span>Registros de Archivo Único</span>
          <v-btn icon @click="dialogListado = false"><v-icon>fas fa-times</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="headersListado" :items="listado" :loading="cargandoListado" dense>
            <template #[`item.repuestos`]="{ item }">
              {{ (item.repuestos || []).length }}
            </template>
            <template #[`item.archivos`]="{ item }">
              {{ (item.archivos || []).length }}
            </template>
            <template #[`item.acciones`]="{ item }">
              <v-btn x-small outlined color="primary" @click="abrirEditar(item)">
                <v-icon x-small left>fas fa-edit</v-icon>Editar
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEditar" max-width="900px">
      <v-card>
        <v-card-title>Editar registro #{{ editForm.id || '—' }}</v-card-title>
        <v-card-text>
          <v-text-field v-model="editForm.orden_servicio_id" label="Orden de servicio" outlined dense disabled />

          <div class="subtitle-2 mb-2 recepcion-section-title">Fotos actuales</div>

          <div class="field-label">Foto parte implicada en la falla</div>
          <div class="thumb-grid mb-3">
            <div v-for="a in getEditFallasActivos()" :key="`ef-${a.id}`" class="thumb-cell">
              <img :src="a.archivo_url" alt="" @click="openViewer(a.archivo_url, tipoArchivoLabel(a.tipo_archivo, a.orden))">
              <div class="thumb-kind">{{ tipoArchivoLabel(a.tipo_archivo, a.orden) }}</div>
              <v-btn small color="error" class="edit-delete-btn" @click="eliminarArchivoExistente(a.id)">
                Eliminar
              </v-btn>
            </div>
            <div v-for="(url, i) in editForm.previewNuevosFalla" :key="`nwf-${i}`" class="thumb-cell">
              <img :src="url" alt="" @click="openViewer(url, `Nueva falla ${i + 1}`)">
              <div class="thumb-kind">Falla nueva #{{ i + 1 }}</div>
              <v-btn small color="error" class="edit-delete-btn" @click="removeEditFallaNuevo(i)">
                Eliminar
              </v-btn>
            </div>
            <button type="button" class="upload-placeholder" @click="$refs.inEditFallas.click()">
              <v-icon color="primary" size="64">fas fa-plus</v-icon>
            </button>
          </div>
          <input ref="inEditFallas" type="file" accept="image/*" multiple class="d-none" @change="onPickEditFallas">

          <v-row dense>
            <v-col cols="12" sm="6">
              <div class="field-label">Foto odómetro</div>
              <button v-if="!getEditSingleActivo('ODOMETRO') && !editForm.previewNuevoOdometro" type="button"
                class="upload-placeholder upload-placeholder--single" @click="$refs.inEditOdometro.click()">
                <v-icon color="primary" size="48">fas fa-plus</v-icon>
                <span class="upload-hint">Tocá para agregar</span>
              </button>
              <div v-else class="thumb-cell thumb-cell--single">
                <img :src="editPreviewSingleUrl('ODOMETRO')" alt=""
                  @click="openViewer(editPreviewSingleUrl('ODOMETRO'), 'Odómetro')">
                <div class="thumb-kind">{{ editForm.previewNuevoOdometro ? 'Odómetro nuevo' : 'Odómetro' }}</div>
                <v-btn small color="error" class="edit-delete-btn" @click="clearEditSingle('ODOMETRO')">Eliminar</v-btn>
              </div>
              <input ref="inEditOdometro" type="file" accept="image/*" class="d-none" @change="onPickEditSingle($event, 'ODOMETRO')">
            </v-col>
            <v-col cols="12" sm="6">
              <div class="field-label">Foto VIN</div>
              <button v-if="!getEditSingleActivo('VIN') && !editForm.previewNuevoVin" type="button"
                class="upload-placeholder upload-placeholder--single" @click="$refs.inEditVin.click()">
                <v-icon color="primary" size="48">fas fa-plus</v-icon>
                <span class="upload-hint">Tocá para agregar</span>
              </button>
              <div v-else class="thumb-cell thumb-cell--single">
                <img :src="editPreviewSingleUrl('VIN')" alt=""
                  @click="openViewer(editPreviewSingleUrl('VIN'), 'VIN')">
                <div class="thumb-kind">{{ editForm.previewNuevoVin ? 'VIN nuevo' : 'VIN' }}</div>
                <v-btn small color="error" class="edit-delete-btn" @click="clearEditSingle('VIN')">Eliminar</v-btn>
              </div>
              <input ref="inEditVin" type="file" accept="image/*" class="d-none" @change="onPickEditSingle($event, 'VIN')">
            </v-col>
          </v-row>

          <div class="field-label mt-3">Print de consulta al CAT (opcional)</div>
          <div class="thumb-grid mb-3">
            <div v-for="a in getEditCatsActivos()" :key="`ec-${a.id}`" class="thumb-cell">
              <img :src="a.archivo_url" alt="" @click="openViewer(a.archivo_url, tipoArchivoLabel(a.tipo_archivo, a.orden))">
              <div class="thumb-kind">{{ tipoArchivoLabel(a.tipo_archivo, a.orden) }}</div>
              <v-btn small color="error" class="edit-delete-btn" @click="eliminarArchivoExistente(a.id)">
                Eliminar
              </v-btn>
            </div>
            <div v-for="(url, i) in editForm.previewNuevosCat" :key="`nwc-${i}`" class="thumb-cell">
              <img :src="url" alt="" @click="openViewer(url, `Nuevo CAT ${i + 1}`)">
              <div class="thumb-kind">CAT nuevo #{{ i + 1 }}</div>
              <v-btn small color="error" class="edit-delete-btn" @click="removeEditCatNuevo(i)">
                Eliminar
              </v-btn>
            </div>
            <button type="button" class="upload-placeholder" @click="$refs.inEditCat.click()">
              <v-icon color="primary" size="64">fas fa-plus</v-icon>
            </button>
          </div>
          <input ref="inEditCat" type="file" accept="image/*" multiple class="d-none" @change="onPickEditCat">

          <v-row dense>
            <v-col cols="12" sm="6">
              <div class="field-label">Foto de la patente (opcional)</div>
              <button v-if="!getEditSingleActivo('PATENTE') && !editForm.previewNuevoPatente" type="button"
                class="upload-placeholder upload-placeholder--single" @click="$refs.inEditPatente.click()">
                <v-icon color="primary" size="48">fas fa-plus</v-icon>
                <span class="upload-hint">Tocá para agregar</span>
              </button>
              <div v-else class="thumb-cell thumb-cell--single">
                <img :src="editPreviewSingleUrl('PATENTE')" alt=""
                  @click="openViewer(editPreviewSingleUrl('PATENTE'), 'Patente')">
                <div class="thumb-kind">{{ editForm.previewNuevoPatente ? 'Patente nueva' : 'Patente' }}</div>
                <v-btn small color="error" class="edit-delete-btn" @click="clearEditSingle('PATENTE')">Eliminar</v-btn>
              </div>
              <input ref="inEditPatente" type="file" accept="image/*" class="d-none" @change="onPickEditSingle($event, 'PATENTE')">
            </v-col>
          </v-row>

          <v-divider class="my-4" />
          <div class="subtitle-2 mb-2">Repuestos</div>
          <v-row dense v-for="(r, i) in editForm.repuestos" :key="`er-${i}`">
            <v-col cols="12" sm="7">
              <v-text-field v-model="r.numero_parte" label="Número de parte" outlined dense hide-details />
            </v-col>
            <v-col cols="8" sm="4">
              <v-text-field
                v-model.number="r.cantidad"
                label="Cantidad"
                type="number"
                min="1"
                step="1"
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col cols="4" sm="1" class="d-flex justify-center align-start repuesto-delete-col">
              <v-btn icon x-small color="error" class="repuesto-delete-btn" @click="editForm.repuestos.splice(i, 1)">
                <v-icon small>fas fa-trash</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-btn small outlined @click="editForm.repuestos.push({ numero_parte: '', cantidad: 1 })">Agregar repuesto</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cerrarDialogEditar">Cancelar</v-btn>
          <v-btn color="primary" :loading="guardandoEdicion" @click="guardarEdicion">Guardar cambios</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ImgViewer v-model="viewerOpen" :img="viewerImg" :nombre="viewerNombre" />

    <v-snackbar v-model="snackbar.value" :color="snackbar.color" timeout="4000">{{ snackbar.text }}</v-snackbar>
  </v-container>
</template>

<script>
import ImgViewer from '../../../components/util/ImgViewer.vue'

export default {
  name: 'RecepcionGarantias',

  components: {
    ImgViewer
  },

  data() {
    return {
      formValido: false,
      enviando: false,
      ordenServicio: '',
      fotoOdometro: null,
      previewOdometro: '',
      fotoVin: null,
      previewVin: '',
      fotosFalla: [],
      previewFallas: [],
      fotoPatente: null,
      previewPatente: '',
      fotosCat: [],
      previewCat: [],
      viewerOpen: false,
      viewerImg: '',
      viewerNombre: '',
      repuestos: [],
      dialogListado: false,
      cargandoListado: false,
      listado: [],
      dialogEditar: false,
      guardandoEdicion: false,
      editForm: {
        id: null,
        orden_servicio_id: '',
        repuestos: [],
        archivos: [],
        archivosEliminarIds: [],
        autoDeleteArchivoIds: [],
        nuevosArchivosFalla: [],
        previewNuevosFalla: [],
        nuevosArchivosCat: [],
        previewNuevosCat: [],
        nuevoArchivoOdometro: null,
        previewNuevoOdometro: '',
        nuevoArchivoVin: null,
        previewNuevoVin: '',
        nuevoArchivoPatente: null,
        previewNuevoPatente: ''
      },
      headersListado: [
        { text: 'ID', value: 'id' },
        { text: 'Orden servicio', value: 'orden_servicio_id' },
        { text: 'Fotos', value: 'archivos' },
        { text: 'Repuestos', value: 'repuestos' },
        { text: 'Acciones', value: 'acciones', sortable: false }
      ],
      snackbar: { value: false, text: '', color: '' }
    }
  },

  beforeDestroy() {
    this.revokeMainObjectUrls()
    this.revokeEditObjectUrls()
  },
  computed: {
    reglasOrden() {
      return [(v) => !!String(v || '').trim() || 'Campo requerido']
    },
    fotosCompletas() {
      return !!this.fotoOdometro && !!this.fotoVin && this.fotosFalla.length > 0
    },
    puedeEnviar() {
      return !!String(this.ordenServicio || '').trim() && this.fotosCompletas
    }
  },
  methods: {
    revokeMainObjectUrls() {
      ;[this.previewOdometro, this.previewVin, this.previewPatente].forEach((u) => {
        if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      })
      this.previewFallas.forEach((u) => {
        if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      })
      this.previewCat.forEach((u) => {
        if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      })
    },
    openViewer(img, nombre) {
      if (!img) return
      this.viewerImg = img
      this.viewerNombre = nombre || 'Imagen'
      this.viewerOpen = true
    },
    tipoArchivoLabel(tipo, orden) {
      const map = {
        FALLA: 'Falla',
        ODOMETRO: 'Odómetro',
        VIN: 'VIN',
        PATENTE: 'Patente',
        CAT: 'CAT'
      }
      const t = String(tipo || '').toUpperCase()
      const base = map[t] || 'Foto'
      if ((t === 'FALLA' || t === 'CAT') && Number(orden) > 0) return `${base} #${orden}`
      return base
    },
    mostrarSnackbar(text, color = 'info') {
      this.snackbar = { value: true, text, color }
    },
    onPickSingle(e, keyFile, keyPreview) {
      const f = (e.target.files || [])[0]
      e.target.value = ''
      if (!f || !f.type.startsWith('image/')) return
      if (this[keyPreview] && this[keyPreview].startsWith('blob:')) URL.revokeObjectURL(this[keyPreview])
      this[keyFile] = f
      this[keyPreview] = URL.createObjectURL(f)
    },
    clearSingle(keyFile, keyPreview) {
      if (this[keyPreview] && this[keyPreview].startsWith('blob:')) URL.revokeObjectURL(this[keyPreview])
      this[keyFile] = null
      this[keyPreview] = ''
    },
    onPickFallas(e) {
      const files = Array.from(e.target.files || []).filter((f) => f.type.startsWith('image/'))
      e.target.value = ''
      for (const f of files) {
        this.fotosFalla.push(f)
        this.previewFallas.push(URL.createObjectURL(f))
      }
    },
    removeFalla(i) {
      const u = this.previewFallas[i]
      if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      this.previewFallas.splice(i, 1)
      this.fotosFalla.splice(i, 1)
    },
    onPickCat(e) {
      const files = Array.from(e.target.files || []).filter((f) => f.type.startsWith('image/'))
      e.target.value = ''
      for (const f of files) {
        this.fotosCat.push(f)
        this.previewCat.push(URL.createObjectURL(f))
      }
    },
    removeCat(i) {
      const u = this.previewCat[i]
      if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      this.previewCat.splice(i, 1)
      this.fotosCat.splice(i, 1)
    },
    addRepuesto() {
      this.repuestos.push({ numero_parte: '', cantidad: 1 })
    },
    cantidadRepuestoPayload(raw) {
      const n = Number(raw)
      if (!Number.isFinite(n) || !Number.isInteger(n) || n < 1) return 1
      return n
    },
    removeRepuesto(i) {
      this.repuestos.splice(i, 1)
    },
    extFromFile(file) {
      const n = (file && file.name) || ''
      const dot = n.lastIndexOf('.')
      return dot >= 0 ? n.slice(dot).toLowerCase() : '.jpg'
    },
    fileToBase64(file) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = (ev) => resolve(ev.target.result)
        reader.readAsDataURL(file)
      })
    },
    async armarPayload() {
      const archivos = []
      const nombreArchivos = []

      archivos.push(await this.fileToBase64(this.fotoOdometro))
      nombreArchivos.push(`odometro${this.extFromFile(this.fotoOdometro)}`)
      archivos.push(await this.fileToBase64(this.fotoVin))
      nombreArchivos.push(`vin${this.extFromFile(this.fotoVin)}`)

      let idxF = 0
      for (const f of this.fotosFalla) {
        idxF += 1
        archivos.push(await this.fileToBase64(f))
        nombreArchivos.push(`falla_${String(idxF).padStart(2, '0')}${this.extFromFile(f)}`)
      }
      if (this.fotoPatente) {
        archivos.push(await this.fileToBase64(this.fotoPatente))
        nombreArchivos.push(`patente${this.extFromFile(this.fotoPatente)}`)
      }
      let idxC = 0
      for (const f of this.fotosCat) {
        idxC += 1
        archivos.push(await this.fileToBase64(f))
        nombreArchivos.push(`cat_${String(idxC).padStart(2, '0')}${this.extFromFile(f)}`)
      }

      return {
        orden_servicio_id: Number(this.ordenServicio),
        archivos,
        nombreArchivos,
        repuestos: this.repuestos
          .map((r) => ({
            numero_parte: String(r.numero_parte || '').trim(),
            cantidad: this.cantidadRepuestoPayload(r.cantidad)
          }))
          .filter((r) => r.numero_parte)
      }
    },
    async enviar() {
      if (!this.$refs.form.validate()) return
      if (!this.fotosCompletas) return this.mostrarSnackbar('Completá las fotos obligatorias.', 'warning')
      this.enviando = true
      try {
        const payload = await this.armarPayload()
        const res = await this.$store.dispatch('postventaTickets/garantiasEvidencias', payload)
        if (res.exito) {
          this.mostrarSnackbar(res.message || 'Los datos fueron cargados con éxito.', 'success')
          this.resetForm()
        } else {
          this.mostrarSnackbar(res.message || 'Error al enviar.', 'error')
        }
      } catch (e) {
        this.mostrarSnackbar(e.message || 'Error de red.', 'error')
      } finally {
        this.enviando = false
      }
    },
    resetForm() {
      this.revokeMainObjectUrls()
      this.ordenServicio = ''
      this.fotoOdometro = null
      this.previewOdometro = ''
      this.fotoVin = null
      this.previewVin = ''
      this.fotoPatente = null
      this.previewPatente = ''
      this.fotosFalla = []
      this.previewFallas = []
      this.fotosCat = []
      this.previewCat = []
      this.repuestos = []
      this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation())
    },
    async abrirListado() {
      this.dialogListado = true
      this.cargandoListado = true
      try {
        const res = await this.$store.dispatch('postventaTickets/getGarantiasEvidenciasListado')
        this.listado = res.exito ? (res.data || []) : []
      } finally {
        this.cargandoListado = false
      }
    },
    abrirEditar(item) {
      this.editForm = {
        id: item.id,
        orden_servicio_id: item.orden_servicio_id,
        repuestos: (item.repuestos || []).map((r) => {
          const q = Number(r.cantidad)
          return {
            numero_parte: r.numero_parte || '',
            cantidad: Number.isInteger(q) && q >= 1 ? q : 1
          }
        }),
        archivos: item.archivos || [],
        archivosEliminarIds: [],
        autoDeleteArchivoIds: [],
        nuevosArchivosFalla: [],
        previewNuevosFalla: [],
        nuevosArchivosCat: [],
        previewNuevosCat: [],
        nuevoArchivoOdometro: null,
        previewNuevoOdometro: '',
        nuevoArchivoVin: null,
        previewNuevoVin: '',
        nuevoArchivoPatente: null,
        previewNuevoPatente: ''
      }
      this.dialogEditar = true
    },
    cerrarDialogEditar() {
      this.revokeEditObjectUrls()
      this.dialogEditar = false
    },
    revokeEditObjectUrls() {
      ;(this.editForm.previewNuevosFalla || []).forEach((u) => {
        if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      })
      ;(this.editForm.previewNuevosCat || []).forEach((u) => {
        if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      })
      ;[
        this.editForm.previewNuevoOdometro,
        this.editForm.previewNuevoVin,
        this.editForm.previewNuevoPatente
      ].forEach((u) => {
        if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      })
    },
    marcarArchivoEliminar(id) {
      if (!this.editForm.archivosEliminarIds.includes(id)) {
        this.editForm.archivosEliminarIds.push(id)
      }
    },
    desmarcarArchivoEliminar(id) {
      const idx = this.editForm.archivosEliminarIds.indexOf(id)
      if (idx >= 0) this.editForm.archivosEliminarIds.splice(idx, 1)
    },
    eliminarArchivoExistente(id) {
      this.marcarArchivoEliminar(id)
      const autoIdx = this.editForm.autoDeleteArchivoIds.indexOf(id)
      if (autoIdx >= 0) this.editForm.autoDeleteArchivoIds.splice(autoIdx, 1)
    },
    getEditFallasActivos() {
      return (this.editForm.archivos || []).filter(
        (a) =>
          String(a.tipo_archivo || '').toUpperCase() === 'FALLA' &&
          !this.editForm.archivosEliminarIds.includes(a.id)
      )
    },
    getEditCatsActivos() {
      return (this.editForm.archivos || []).filter(
        (a) =>
          String(a.tipo_archivo || '').toUpperCase() === 'CAT' &&
          !this.editForm.archivosEliminarIds.includes(a.id)
      )
    },
    getEditSingleActivo(tipo) {
      const t = String(tipo || '').toUpperCase()
      return (this.editForm.archivos || []).find(
        (a) =>
          String(a.tipo_archivo || '').toUpperCase() === t &&
          !this.editForm.archivosEliminarIds.includes(a.id)
      )
    },
    editPreviewSingleUrl(tipo) {
      const t = String(tipo || '').toUpperCase()
      const map = {
        ODOMETRO: 'previewNuevoOdometro',
        VIN: 'previewNuevoVin',
        PATENTE: 'previewNuevoPatente'
      }
      const previewKey = map[t]
      if (previewKey && this.editForm[previewKey]) return this.editForm[previewKey]
      const a = this.getEditSingleActivo(tipo)
      return (a && a.archivo_url) || ''
    },
    getEditSingleOriginal(tipo) {
      const t = String(tipo || '').toUpperCase()
      return (this.editForm.archivos || []).find((a) => String(a.tipo_archivo || '').toUpperCase() === t)
    },
    onPickEditFallas(e) {
      const files = Array.from(e.target.files || []).filter((f) => f.type && f.type.startsWith('image/'))
      e.target.value = ''
      for (const f of files) {
        this.editForm.nuevosArchivosFalla.push(f)
        this.editForm.previewNuevosFalla.push(URL.createObjectURL(f))
      }
    },
    removeEditFallaNuevo(i) {
      const u = this.editForm.previewNuevosFalla[i]
      if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      this.editForm.previewNuevosFalla.splice(i, 1)
      this.editForm.nuevosArchivosFalla.splice(i, 1)
    },
    onPickEditCat(e) {
      const files = Array.from(e.target.files || []).filter((f) => f.type && f.type.startsWith('image/'))
      e.target.value = ''
      for (const f of files) {
        this.editForm.nuevosArchivosCat.push(f)
        this.editForm.previewNuevosCat.push(URL.createObjectURL(f))
      }
    },
    removeEditCatNuevo(i) {
      const u = this.editForm.previewNuevosCat[i]
      if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      this.editForm.previewNuevosCat.splice(i, 1)
      this.editForm.nuevosArchivosCat.splice(i, 1)
    },
    onPickEditSingle(e, tipo) {
      const file = (e.target.files || [])[0]
      e.target.value = ''
      if (!file || !file.type || !file.type.startsWith('image/')) return
      const map = {
        ODOMETRO: ['nuevoArchivoOdometro', 'previewNuevoOdometro'],
        VIN: ['nuevoArchivoVin', 'previewNuevoVin'],
        PATENTE: ['nuevoArchivoPatente', 'previewNuevoPatente']
      }
      const pair = map[String(tipo || '').toUpperCase()]
      if (!pair) return
      const [fileKey, previewKey] = pair
      const prev = this.editForm[previewKey]
      if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev)
      const existente = this.getEditSingleActivo(tipo)
      if (existente?.id) {
        this.marcarArchivoEliminar(existente.id)
        if (!this.editForm.autoDeleteArchivoIds.includes(existente.id)) {
          this.editForm.autoDeleteArchivoIds.push(existente.id)
        }
      }
      this.editForm[fileKey] = file
      this.editForm[previewKey] = URL.createObjectURL(file)
    },
    clearEditSingle(tipo) {
      const t = String(tipo || '').toUpperCase()
      const map = {
        ODOMETRO: ['nuevoArchivoOdometro', 'previewNuevoOdometro'],
        VIN: ['nuevoArchivoVin', 'previewNuevoVin'],
        PATENTE: ['nuevoArchivoPatente', 'previewNuevoPatente']
      }
      const pair = map[t]
      if (pair) {
        const [fileKey, previewKey] = pair
        const prev = this.editForm[previewKey]
        const teniaPreviewNueva = !!prev
        if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev)
        this.editForm[fileKey] = null
        this.editForm[previewKey] = ''
        if (teniaPreviewNueva) {
          const original = this.getEditSingleOriginal(t)
          if (original?.id && this.editForm.autoDeleteArchivoIds.includes(original.id)) {
            this.desmarcarArchivoEliminar(original.id)
            this.editForm.autoDeleteArchivoIds = this.editForm.autoDeleteArchivoIds.filter((id) => id !== original.id)
            return
          }
        }
      }
      const existente = this.getEditSingleActivo(t)
      if (existente?.id) this.marcarArchivoEliminar(existente.id)
    },
    validarEdicionFotosObligatorias() {
      const fallasCount = this.getEditFallasActivos().length + (this.editForm.nuevosArchivosFalla || []).length
      const hasOdometro = !!this.getEditSingleActivo('ODOMETRO') || !!this.editForm.nuevoArchivoOdometro
      const hasVin = !!this.getEditSingleActivo('VIN') || !!this.editForm.nuevoArchivoVin
      if (fallasCount < 1 || !hasOdometro || !hasVin) {
        return 'No se puede guardar: deben quedar al menos una foto de la falla, odómetro y VIN.'
      }
      return null
    },
    async guardarEdicion() {
      if (!this.editForm.id) return
      const errFotos = this.validarEdicionFotosObligatorias()
      if (errFotos) {
        this.mostrarSnackbar(errFotos, 'warning')
        return
      }
      this.guardandoEdicion = true
      try {
        const archivos = []
        const nombreArchivos = []
        let idxFalla = 0
        for (const f of this.editForm.nuevosArchivosFalla || []) {
          if (!f || !f.type || !f.type.startsWith('image/')) continue
          idxFalla += 1
          archivos.push(await this.fileToBase64(f))
          nombreArchivos.push(`falla_${String(idxFalla).padStart(2, '0')}${this.extFromFile(f)}`)
        }
        let idxCat = 0
        for (const f of this.editForm.nuevosArchivosCat || []) {
          if (!f || !f.type || !f.type.startsWith('image/')) continue
          idxCat += 1
          archivos.push(await this.fileToBase64(f))
          nombreArchivos.push(`cat_${String(idxCat).padStart(2, '0')}${this.extFromFile(f)}`)
        }
        const pushSingle = async (file, nombreBase) => {
          if (!file || !file.type || !file.type.startsWith('image/')) return
          archivos.push(await this.fileToBase64(file))
          nombreArchivos.push(`${nombreBase}${this.extFromFile(file)}`)
        }
        await pushSingle(this.editForm.nuevoArchivoOdometro, 'odometro')
        await pushSingle(this.editForm.nuevoArchivoVin, 'vin')
        await pushSingle(this.editForm.nuevoArchivoPatente, 'patente')

        const payload = {
          evidencia_id: this.editForm.id,
          archivos,
          nombreArchivos,
          archivos_eliminar_ids: this.editForm.archivosEliminarIds,
          repuestos: (this.editForm.repuestos || [])
            .map((r) => ({
              numero_parte: String(r.numero_parte || '').trim(),
              cantidad: this.cantidadRepuestoPayload(r.cantidad)
            }))
            .filter((r) => r.numero_parte)
        }
        const res = await this.$store.dispatch('postventaTickets/actualizarGarantiasEvidencias', payload)
        if (res.exito) {
          this.mostrarSnackbar(res.message || 'Registro actualizado.', 'success')
          this.cerrarDialogEditar()
          await this.abrirListado()
        } else {
          this.mostrarSnackbar(res.message || 'No se pudo actualizar.', 'error')
        }
      } finally {
        this.guardandoEdicion = false
      }
    }
  }
}
</script>

<style scoped>
.field-label {
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 8px;
  color: var(--v-tabText-base);
}

.recepcion-section-title {
  color: var(--v-tabText-base);
}

.thumb-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-start;
}

.upload-placeholder {
  border: 2px dashed rgba(0, 0, 0, 0.38);
  border-radius: 8px;
  width: 100%;
  max-width: 280px;
  min-height: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.02);
  transition: border-color 0.2s ease, background 0.2s ease;
  padding: 12px;
}

.upload-placeholder:hover {
  border-color: var(--v-primary-base, #1976d2);
  background: rgba(25, 118, 210, 0.04);
}

.upload-placeholder--single {
  width: 100%;
}

.upload-hint {
  margin-top: 8px;
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.54);
}

.thumb-cell {
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.12);
  flex-shrink: 0;
}

.thumb-cell--single {
  width: 100%;
  max-width: 280px;
  height: 160px;
}

.thumb-cell img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: zoom-in;
  display: block;
}

.thumb-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(0, 0, 0, 0.55) !important;
}

.thumb-kind {
  position: absolute;
  top: 4px;
  left: 4px;
  font-size: 0.65rem;
  line-height: 1;
  font-weight: 700;
  color: #fff;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 4px;
  padding: 4px 6px;
  z-index: 2;
}

.edit-delete-btn {
  position: absolute;
  left: 6px;
  bottom: 6px;
  min-width: 70px !important;
  z-index: 2;
}

::v-deep .v-dialog .v-card__title {
  color: var(--v-tabText-base);
}

.recepcion-dark .field-label {
  color: var(--v-tabText-base);
}

.recepcion-dark .upload-placeholder {
  border-color: rgba(255, 255, 255, 0.32);
  background: rgba(255, 255, 255, 0.04);
}

.recepcion-dark .upload-placeholder:hover {
  border-color: var(--v-primary-base, #1976d2);
  background: rgba(25, 118, 210, 0.18);
}

.recepcion-dark .upload-hint {
  color: rgba(255, 255, 255, 0.72);
}

.recepcion-dark .thumb-cell {
  border-color: rgba(255, 255, 255, 0.28);
}

.repuesto-row {
  align-items: center;
}

.repuesto-delete-col {
  min-height: 40px;
}

.repuesto-delete-btn {
  margin-top: 4px;
}

@media (max-width: 600px) {
  .field-label {
    text-align: center;
  }

  .thumb-grid {
    justify-content: center;
  }

  .upload-placeholder,
  .thumb-cell--single {
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
